import { type ILinkAuth } from '@/utils/linkAuth';

export const tenantSettingsSidebarItems: ILinkAuth[] = [
  {
    label: 'Geral',
    to: '/settings',
    authorization: ({ can }) => can('list', 'memberships'),
  },
  {
    label: 'Funções',
    to: '/settings/roles',
  },
  {
    label: 'Departamentos',
    to: '/settings/company-departments',
    authorization: ({ can }) => can('list', 'departments'),
  },
  {
    label: 'Check List',
    to: '/settings/hang-tag/check-list',
    authorization: ({ can }) => can('list', 'checklists'),
  },
  {
    label: 'Categorias de Documentos',
    to: '/settings/document-categories',
    authorization: ({ can }) => can('list', 'document_categories'),
  },
  {
    label: 'Integrações GPS',
    to: '/settings/gps-integrations',
    authorization: ({ can }) => can('list', 'departments'),
  },
];
